export enum FeatureToggle {
  OrderModalAuthMode = 'orderModalAuthMode',
  adyenCreditCard = 'adyenCreditCard',
  applePay = 'applePay',
  hardcodeNoindexNofollow = 'hardcodeNoindexNofollow',
  isActivationPageContentFromCBE = 'isActivationPageContentFromCBE',
  isAdyenApplePay = 'isAdyenApplePay',
  isAdyenBlikOn = 'isAdyenBlikOn',
  isAdyenPayPal = 'isAdyenPayPal',
  isAdyenPrzelewyOn = 'isAdyenPrzelewyOn',
  isAnchorLink = 'isAnchorLink',
  isBiggerProductImageOnMobile = 'isBiggerProductImageOnMobile',
  isBusinessPageV3 = 'isBusinessPageV3',
  isCBBEFrench = 'isCBBEFrench',
  isCOPFilter = 'isCOPFilter',
  isCheckOutButtonV2On = 'isCheckOutButtonV2On',
  isCollectBillingInfoOn = 'isCollectBillingInfoOn',
  isContactPageDynamically = 'isContactPageDynamically',
  isCookiesFooterLinkOn = 'isCookiesFooterLinkOn',
  isDeliveryInformationAdditionalFieldOn = 'isDeliveryInformationAdditionalFieldOn',
  isDeliveryQuantity = 'isDeliveryQuantity',
  isDigitalWrappersAndPersonalNoteEnabled = 'isDigitalWrappersAndPersonalNoteEnabled',
  isEmblaSliderOn = 'isEmblaSliderOn',
  isErrorMessages = 'isErrorMessages',
  isFeaturedCards = 'isFeaturedCards',
  isFooterLogos = 'isFooterLogos',
  isGCSOrangeColor = 'isGCSOrangeColor',
  isGooglePayOn = 'isGooglePayOn',
  isGoogleRecaptchaBadgeHidden = 'isGoogleRecaptchaBadgeHidden',
  isHandV1 = 'isHandV1',
  isHiddenPhysicalDeliveryDate = 'isHiddenPhysicalDeliveryDate',
  isLangSwitcherFixOn = 'isLangSwitcherFixOn',
  isLocalizePaymentMethodDescription = 'isLocalizePaymentMethodDescription',
  isLogosFromCBEOn = 'isLogosFromCBEOn',
  isNavigationIconTextOn = 'isNavigationIconTextOn',
  isNewPaymentLogos = 'isNewPaymentLogos',
  isNewVariationsView = 'isNewVariationsView',
  isNoPublishDate = 'isNoPublishDate',
  isOrderParam = 'isOrderParam',
  isOrganizationStructuredDataOn = 'isOrganizationStructuredDataOn',
  isPDPBusinessModalUsps = 'isPDPBusinessModalUsps',
  isPDPButtonV1 = 'isPDPButtonV1',
  isPDPVariationsOnFlyOn = 'isPDPVariationsOnFlyOn',
  isPayPalEmailWarning = 'isPayPalEmailWarning',
  isPaymentIconsFromCBEOn = 'isPaymentIconsFromCBEOn',
  isPersonalNotePlaceholder = 'isPersonalNotePlaceholder',
  isPhysicalOrderDescriptionOnThankYouPages = 'isPhysicalOrderDescriptionOnThankYouPages',
  isRedeemBrandLogosOn = 'isRedeemBrandLogosOn',
  isRedeemFAQAndSEOSectionsOn = 'isRedeemFAQAndSEOSectionsOn',
  isRedeemHeaderVideoOn = 'isRedeemHeaderVideoOn',
  isRedeemLanguageSwitcher = 'isRedeemLanguageSwitcher',
  isRedeemSpecificDoublerModalOn = 'isRedeemSpecificDoublerModalOn',
  isRedeemUnusedCardsOn = 'isRedeemUnusedCardsOn',
  isSearchDataLayer = 'isSearchDataLayer',
  isSearchV1 = 'isSearchV1',
  isSeoBlocksCollapse = 'isSeoBlocksCollapse',
  isShipmentMethodsEnabled = 'isShipmentMethodsEnabled',
  isVariationsOnFlyOn = 'isVariationsOnFlyOn',
  languageSwitcher = 'languageSwitcher',
  promoPopup = 'promoPopup',
  redeemDelayWarning = 'redeemDelayWarning',
}

export type FeatureToggleValues = {
  [key in FeatureToggle]: boolean
};
